import { useContext, useEffect, useState } from "react";
import superagent from "superagent";

function useDataFetch<T>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestBody?: Record<string, any>
): [T | undefined, boolean, string?] {
  const [data, setData] = useState<T | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    let isMounted = true;

    if (!url || url.includes("undefined")) {
      return;
    }

    setLoading(true);
    let req: superagent.Request;
    switch (method) {
      case "GET":
        req = superagent.get(url);
        break;
      case "POST":
        req = superagent.post(url);
        break;
      case "PUT":
        req = superagent.put(url);
        break;
      case "DELETE":
        req = superagent.delete(url);
        break;
      default:
        throw new Error("Unsupported HTTP method");
    }

    if (requestBody) {
      req.send(requestBody);
    }

    req
      .then((res) => {
        if (isMounted) {
          setData(res.body);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        if (isMounted) {
          setLoading(false);
          setError(err.message);
        }
      });

    return () => {
      isMounted = false;
      if (req && req.abort) {
        req.abort();
      }
    };
  }, [url, method, requestBody]);

  return [data, loading, error];
}

export default useDataFetch;
